import {
  SAVE_AGE_VALIDATION,
  SAVE_IS_OF_AGE,
} from '@core/reducers/user/actionTypes';
import { sessionCache, KEYS } from '@services/cache';

import getPropFromSession from '../selectors/getPropFromSession';
import {
  AGE_VALIDATION_SESSION_KEY,
  AGE_VALIDATION_AGE_SESSION_KEY,
} from '../constants';

const saveAgeValidation = ({ date, type }) => dispatch => {
  const user = getPropFromSession() || {};
  if (type === 'DATE_OF_BIRTH') {
    user[AGE_VALIDATION_SESSION_KEY] = date;
  } else if (type === 'IS_OF_AGE') {
    user[AGE_VALIDATION_AGE_SESSION_KEY] = date;
  }
  sessionCache.set(KEYS.USER, user);

  dispatch({
    type: type === 'DATE_OF_BIRTH' ? SAVE_AGE_VALIDATION : SAVE_IS_OF_AGE,
    payload: { date },
  });
};

export default saveAgeValidation;
